import FlightResultSection from './FlightResultSection';
export default FlightResultSection;
